import type { ProjectCloudSnapshot } from '@/backend/contracts';
import type { CloudState } from '@/store/cloud-types';
import type { MetaSlice } from '@/store/types';

interface ProjectHydrationOptions {
    orgId: string;
    projectId: string;
    lastSync: string;
}

interface ProjectHydrationState {
    cloudState: Partial<MetaSlice['cloud']>;
    projectState: Partial<CloudState>;
}

export function splitCloudProjectSnapshotForHydration(
    projectData: ProjectCloudSnapshot,
    options: ProjectHydrationOptions,
): ProjectHydrationState {
    const projectState = { ...projectData } as Partial<ProjectCloudSnapshot>;
    delete projectState.id;
    delete projectState.orgId;
    delete projectState.ownerId;
    delete projectState.isBeta;
    delete projectState.scriptTextAccess;
    delete projectState.communicationAudiences;
    delete projectState.communicationSettings;
    delete projectState.authoritativeResourceIds;

    return {
        projectState: projectState as Partial<CloudState>,
        cloudState: {
            enabled: true,
            orgId: options.orgId,
            projectId: options.projectId,
            lastSync: options.lastSync,
            isBeta: projectData.isBeta,
            scriptTextAccess: projectData.scriptTextAccess,
            communicationAudiences: projectData.communicationAudiences,
            communicationSettings: projectData.communicationSettings,
            authoritativeResourceIds: projectData.authoritativeResourceIds,
            hasLoadedCloudProject: true,
        },
    };
}
